import React from 'react';

import { Label } from './_checkbox';

interface CheckboxProps {
  checked: boolean;
  setChecked: Function;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  setChecked,
  children,
}) => {
  return (
    <Label className="checkbox">
      <input
        type="checkbox"
        checked={checked}
        onChange={() => setChecked(!checked)}
      />

      <span>&#10003;</span>

      <b className="checkbox__label-text">{children}</b>
    </Label>
  );
};
